export default function Style(){
  return (
    <style>
      {`
.roomSliderOne .slick-list .slick-track .slick-slide {
  width: 600px !important;
}

.roomSliderOne .slick-list .slick-track {
  display: flex;
}

.roomSliderOne .slick-list {
  /* overflow: auto; */
  scroll-behavior: smooth;
}
.roomSliderOne .slick-dots li button  {
  background-color: #C6C6C6 !important;
  height: 2px !important; 
  padding: 1px 10px !important;
}
.roomSliderOne .slick-dots .slick-active  button{
  background-color: black !important;
    height: 2px !important;
    padding: 1px 10px !important;
}
 
.roomSliderOne .slick-list .slick-track .slick-slide .imgText {
  position: absolute;
  font-family:'josefin Sans';
  color: white;
  font-size: 18px;
  font-weight: 400;
  bottom: 30px;
  z-index: 1;
 
}
.roomSliderOne .slick-dots {
  display: block !important;
}
.px-custom{
  padding: 0 12px;
}
      `}
    </style>
  );

}
